export { Input } from '@mantine/core'